export function safeJsonParse(str, def) {
  try {
    if (!str) {
      return def;
    }
    return JSON.parse(str);
  } catch (e) {
    return def;
  }
}

export function safeJsonStringify(obj) {
  if (typeof obj !== 'object') {
    return obj;
  }
  return JSON.stringify(obj);
}